import { ArticleStatus } from "@/api/types/main/schemas";
import { FC } from "react";
import { Badge } from "../ui/badge";
import { getHumanReadableStatus } from "@/api/types/helpers/functions";

interface LifeCycleStatusFormProps {
  status: ArticleStatus;
}

//TODO: ЗАМЕНИТЬ НА ФОРМУ
export const LifeCycleStatusForm: FC<LifeCycleStatusFormProps> = ({ status }) => {
  const humanReadableStatus = getHumanReadableStatus(status);
  return (
    <Badge
      className={`${humanReadableStatus.color} hover:${humanReadableStatus.color} hover:opacity-80 whitespace-nowrap w-24 flex justify-center items-center`}
    >
      {humanReadableStatus.value}
    </Badge>
  );
};
